// extracted by mini-css-extract-plugin
module.exports = {"button":"QOAmeC4bW2P6LMnajjH2G","spinnerContainer":"_12h3R_833TFwvWYtsN3z7N","spinnerAppear":"_2iNsEA_v0DF_rG6wheSGEi","spinner":"_2XnvxlznXWVE4lUsskCLoa"};